import { render } from "./SwitchComponentHeader.vue?vue&type=template&id=7cc5cb94&scoped=true"
import script from "./SwitchComponentHeader.vue?vue&type=script&lang=js"
export * from "./SwitchComponentHeader.vue?vue&type=script&lang=js"

import "./SwitchComponentHeader.vue?vue&type=style&index=0&id=7cc5cb94&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc5cb94"]])

export default __exports__